import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Map from "./components/Map";
import Div100vh from "react-div-100vh";
import styled from "styled-components";

const AppContainer = styled(Div100vh)`
	width: 100vw;
	margin: 0;
	padding: 0;
`;

function App() {
	return (
		<Router>
			<AppContainer>
				<Switch>
					<Route exact path="/">
						<Map />
					</Route>
					<Route exact path="/scanner"></Route>
				</Switch>
			</AppContainer>
		</Router>
	);
}

export default App;
